<template>
    <div class="notifications">
        <transition-group name="slide">
            <NotificationsMessage v-for="notification in notifications" v-bind:key="notification.id" v-bind:notification="notification" />
        </transition-group>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import NotificationsMessage from './NotificationsMessage';

    export default {
        name: 'Notification',
        components: {
            NotificationsMessage
        },
        computed: {
            ...mapGetters(['notifications'])
        }
    }
</script>

<style scoped>
    .notifications {
        position: fixed;
        right: 30px;
        bottom: 70px;
        z-index: 100;
    }

    .notifications .slide-enter-active,
    .notifications .slide-leave-active {
        transition: all 0.4s;
    }

    .notifications .slide-enter-from,
    .notifications .slide-leave-to {
        opacity: 0;
        transform: translate(50px, 0);
    }
</style>
